var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBottomRightCorner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 292,
    viewBox: "0 0 99 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.00001V2.00001C53.3895 18.3207 89.0762 66.8165 89.0762 121.689L89.0762 277.501",
    stroke: "#4285F4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6847 291.5L97.1598 271.668H80.2095L88.6847 291.5Z",
    fill: "#4285F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBottomRightCorner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bottom_right_corner.f5602f78a59b1541d02ef74686ee2b87.svg";